import { render, staticRenderFns } from "./AccountDashboardSubscriptions.vue?vue&type=template&id=1f087a26&"
import script from "./AccountDashboardSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./AccountDashboardSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f087a26')) {
      api.createRecord('1f087a26', component.options)
    } else {
      api.reload('1f087a26', component.options)
    }
    module.hot.accept("./AccountDashboardSubscriptions.vue?vue&type=template&id=1f087a26&", function () {
      api.rerender('1f087a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountDashboard/AccountDashboardSubscriptions.vue"
export default component.exports